export * as assets from './assets'
export * as externalInstitutions from './external-institutions'
export * as gl from './gl'
export * as orgStructureSpace from './org-structure-space'
export * as orgStructureSpaceWfuhs from './org-structure-space-wfuhs'
export * as payroll from './payroll'
export * as research from './research'
export * as space from './space'
export * as spaceWfuhs from './space-wfuhs'
export * as spaceUsage from './space-usage'
export * as spaceUsageWfuhs from './space-usage-wfuhs'
export * as spaceLite from './space-lite'
export * as spaceFull from './space-full'
